/**
 * tg-course-detail.js — Course detail v2
 *
 * Carousel behaviour is handled by tg-salon-hero.js (reused asset, loaded
 * separately by the section) via its class-based .tg-sh__carousel query —
 * nothing to duplicate here. This file only owns the expert bio
 * tap-to-reveal toggle, since that behaviour is unique to this section.
 */
(function () {
  'use strict';

  function initExpertToggle(card) {
    var toggle = card.querySelector('.tg-cd__expert-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var isOpen = card.classList.toggle('tg-cd__expert-card--open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('.tg-cd__expert-card').forEach(initExpertToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
